import { render, staticRenderFns } from "./trailerCard.vue?vue&type=template&id=220c1b22&scoped=true&"
import script from "./trailerCard.vue?vue&type=script&lang=js&"
export * from "./trailerCard.vue?vue&type=script&lang=js&"
import style0 from "./trailerCard.vue?vue&type=style&index=0&id=220c1b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c1b22",
  null
  
)

export default component.exports